module.exports = [{"type":"hash","text":"Server time"},{"type":"warning","text":"https://open-api.bingx.com/openApi/spot/v1/server/time"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/basic/04_server_url.json
// module id = GK5R
// module chunks = 3